<template>
  <el-container>
    <el-main>
      <div class="headBack">
        <img src="../assets/首页/蓝背景左下圆.png" class="leftCir" />
        <img src="../assets/首页/蓝背景右上圆.png" class="rightCir" />
      </div>
      <div class="contentDiv">
        <div class="row">
          <img :src="iconUrl" class="icon" />
          <p class="cateTitle">{{ cateName }}</p>
        </div>
        <div class="listArea">
          <div class="item" v-for="index in dataList.length" :key="index">
            <p
              class="num"
              :style="{
                backgroundColor:
                  index == 1
                    ? '#fe741c'
                    : index == 2
                    ? '#fdb80c'
                    : index == 3
                    ? '#ffdc00'
                    : '#f3f5f7',
                color: index > 3 ? '#000000' : '#ffffff',
              }"
              @click="clickItem(dataList[index - 1].url)"
            >
              {{ index }}
            </p>
            <p class="contentStr" @click="clickItem(dataList[index - 1].url)">
              {{ dataList[index - 1].title }}
            </p>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import { getHotNewsMoreList } from "../service/api";
export default {
  components: {},
  data() {
    return {
      dataList: [],
      iconUrl: "",
      cateName: "",
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.$parent.showTopBottomView = true;
    this.$parent.showSearch = true;
    let data = this.$route.query;
    this.iconUrl = data.cateIcon;
    this.cateName = data.cateName + "热搜";
    this.getInfoListAction(data.cateName);
  },
  methods: {
    async getInfoListAction(name) {
      const res = await getHotNewsMoreList(name, 1, 50);
      console.log("res=", res);
      if (res.data.code === 200 && res.data.success) {
        this.dataList = res.data.result.records;
      } else {
        this.$message({
          message: res.data.message,
          type: "warning",
        });
      }
    },
    clickItem(url) {
      const externalLink = url;
      window.open(externalLink, "_blank");
    },
    //点击资讯分类
    async clickCateTag(index) {
      this.infoCateSelectedIndex = index;
      let cate = this.infoCategoriesList[index];
      this.getInfoListAction(cate.id);
      console.log("this.infoList=", this.infoList);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-main {
  background-color: #f3f5f7;
  position: relative;
}
.headBack {
  position: absolute;
  left: 0px;
  top: 0px;
  background-color: #4972f0;
  width: 100%;
  height: 500px;
}
.leftCir {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 223px;
}
.rightCir {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 224px;
}
.contentDiv {
  display: flex;
  position: relative;
  flex-direction: column;
  z-index: 1;
  padding: 0px 240px;
}
.icon {
  margin-left: 40px;
  width: 120px;
  border-radius: 70px;
  border-width: 10px;
  border-color: rgba(255, 255, 255, 0.4);
  border-style: solid;
}
.cateTitle {
  margin-left: 40px;
  color: #ffffff;
  font-size: 48px;
  font-weight: bold;
}
.row {
  margin-top: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.listArea {
  width: 100%;
  border-style: none;
  display: flex;
  flex-direction: column;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 20px 20px rgba(73, 114, 240, 0.1);
  overflow: hidden;
  margin-top: 60px;
  padding: 50px;
}
.item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.num {
  width: 28px;
  height: 28px;
  border-radius: 10px;
  font-size: 18px;
  color: #ffffff;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
}
.contentStr {
  margin-left: 20px;
  line-height: 28px;
  font-size: 18px;
  color: #000000;
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  .el-main {
    background-color: #f3f5f7;
    position: relative;
  }
  .headBack {
    position: absolute;
    left: 0px;
    top: 0px;
    background-color: #4972f0;
    width: 100%;
    height: 400px;
  }
  .leftCir {
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 223px;
  }
  .rightCir {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 224px;
  }
  .contentDiv {
    display: flex;
    position: relative;
    flex-direction: column;
    z-index: 1;
    padding: 0px 5%;
  }
  .icon {
    margin-left: 10px;
    width: 60px;
    border-radius: 70px;
    border-width: 10px;
    border-color: rgba(255, 255, 255, 0.4);
    border-style: solid;
  }
  .cateTitle {
    margin-left: 40px;
    color: #ffffff;
    font-size: 38px;
    font-weight: bold;
  }
  .row {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .listArea {
    // width: 100%;
    border-style: none;
    display: flex;
    flex-direction: column;
    border-radius: 30px;
    background-color: #ffffff;
    box-shadow: 0 20px 20px rgba(73, 114, 240, 0.1);
    overflow: hidden;
    margin-top: 20px;
    padding: 10px 0px 0px 0px;
    margin-bottom: 40px;
  }
  .item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 15px;
  }
  .num {
    min-width: 28px;
    min-height: 28px;
    border-radius: 10px;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    line-height: 28px;
    cursor: pointer;
    margin: 0px;
  }
  .contentStr {
    margin-left: 20px;
    line-height: 20px;
    font-size: 18px;
    color: #000000;
    cursor: pointer;
    margin: 0px 0px 0px 20px;
  }
}
</style>
